export default __webpack_public_path__ + "static/media/Padron_LondresOpen.0694daed.jpg";